import {Component, Input, OnInit} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {EnumerationService} from '../services/enumeration.service';
import {ApplicationService} from '../services/application.service';

@Component({
  selector: 'app-organization-unit-box-view',
  templateUrl: './organization-unit-box-view.component.html',
  styles: []
})
export class OrganizationUnitBoxViewComponent extends ExcTranslation implements OnInit {

  //@Input()
  //oeID = '';

  @Input()
  data: any = undefined;
  @Input()
  showAddress: any = 1;
  @Input()
  showAllContacts: any = 1;
  @Input()
  showContacts = true;

  oeList = {
    data: [] as any[],
    loadData: (OEs: any) => {
      this.oeList.data = OEs;
    }
  };

  constructor(
    public enumSvc: EnumerationService,
    public appService: ApplicationService,
    private modal: ExgModalService) {
    super();
  }

  ngOnInit(): void {
  }

  getAddress(oe: any, ident: number): any {
    return ExcCoreModule.Array.GetObject(oe.addresses, 'adr_enmIdent_AdresseTyp', ident);
  }

  getKontakt(oe: any, ident: number): any {
    return ExcCoreModule.Array.GetObject(oe.contacts, 'kont_enmIdent_KontaktTyp', ident);
  }

  more(): void {
      this.appService.OE.OeEditor.OpenModal(this.data);
//    this.modal.show('ModalOrganizationUnitBoxComponent', this.data).subscribe();
  }

}
